<app-dialog [disableClose]="true" [width]="700">
  <ng-template #bodyContent>
    <div
      #blurryBloc
      (window:resize)="applyBlurryEffect()"
      (scroll)="applyBlurryEffect()"
      class="orders-payment-edit"
      id="orders-payment-edit"
    >
      <div class="orders-payment-edit-header">
        <h4 class="me-2">{{ 'orders.transactionModification' | translate }}</h4>
        <div class="orders-payment-edit-header-type">
          {{
            (editType === ordersActionType.PaymentEdit ? 'orders.paymentType' : 'orders.refundType')
              | translate
          }}
        </div>
      </div>
      @if (currentPaymentItems?.length) {
      <div class="orders-payment-edit-body">
        @if (editType === ordersActionType.PaymentEdit) {
        <app-summary-list
          title="{{ 'orders.foldersTransactionList' | translate }}"
          [items]="paymentSummary"
          [summaryLabelCallback]="getSummaryLabel"
        >
        </app-summary-list>
        }
        <div class="orders-payment-edit-user-input">
          <h5>{{ 'orders.user' | translate }}</h5>
          <app-customer-dropdown-list
            appendTo="body"
            [data]="operatorData"
            [isLoading]="isOperatorLoading"
            [selectedId]="operatorSelectedId"
            [allowCustomerCreation]="false"
            [allowCustomerEdit]="false"
            [styleClass]="'ng-select-sm'"
            (selectedChange)="onOperatorChange($event)"
            data-cy="user-dropdown"
          ></app-customer-dropdown-list>
        </div>
        <div class="orders-payment-edit-user-input">
          <h5>{{ 'orders.customerPayer' | translate }}</h5>
          <app-customer-dropdown-list
            appendTo="body"
            [data]="payerData"
            [isLoading]="isPayerLoading"
            [selectedId]="payerSelectedId"
            [allowCustomerCreation]="false"
            [allowCustomerEdit]="false"
            [styleClass]="'ng-select-sm'"
            (searchTrigger)="onPayerSearchTrigger($event)"
            (selectedChange)="onCustomerChange($event)"
            data-cy="customer-payer-dropdown"
          ></app-customer-dropdown-list>
        </div>
        <div class="orders-payment-edit-payment-rows pt-4">
          <h5>{{ 'orders.paymentMethod' | translate }}</h5>
          <app-payment-mode-form
            appendTo="body"
            [formGroup]="form"
            [modes]="paymentModes"
            [hiddenPaymentTypes]="true"
            [paymentTypes]="paymentTypes"
            [totalAmount]="totalAmount$ | async"
            (amountToReturnChange)="amountToReturn = $event"
            data-cy="orders-folder-edit-payment-mode"
          >
            <ng-template #paymentActions> </ng-template>
          </app-payment-mode-form>
        </div>
      </div>
      }
    </div>
  </ng-template>
  <ng-template #actionsContent>
    <div [ngClass]="{ visible: isTopBlurryEffectVisible }" class="blurry-on-top"></div>

    <div class="orders-payment-edit-actions">
      <button
        tabindex="-1"
        mat-button
        (click)="closePaymentEdit()"
        data-cy="modification-undo"
        class="tick-btn tick-btn-secondary me-2 mb-1"
      >
        {{ 'orders.modificationUndo' | translate }}
      </button>
      <button
        mat-button
        (click)="submitPaymentEdit()"
        class="tick-btn tick-btn-primary"
        [disabled]="isFormInvalid()"
        data-cy="validate-btn"
      >
        {{ 'shared.actions.validate' | translate }}
      </button>
    </div>
  </ng-template>
</app-dialog>
